import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import RestoreIcon from '@mui/icons-material/Restore';
import { Button, IconButton, Menu, MenuItem, Paper, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "../../config/authaxios";
import { useStyles } from "../../theme/theme";
import Body from "../../ui/Body";
import LinkCategory from "../coupon/category/LinkCategory";
import UnLinkCategory from "./category/UnLinkCategory";
// global veriables
let propsData = {};

// style
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  background: "#fff",
  boxShadow: 24,
  padding: 20,
};


function Kacoupon() {
  // state---->
  const [linkCategory, setLinkCategory] = useState(false);
  const [unlinkCategory, setUnLinkCategory] = useState(false);

  const navigate = useNavigate();
  const classes = useStyles();


  const [coupons, setCoupons] = useState([]);
  const [isdeleteId, setIsDeleteId] = useState();
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [isMore, setIsMore] = useState(false);
  const [load, setLoad] = useState(false);
  const [nodata, setNodata] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [pageSize, setPageSize] = useState(25);
  const [hidenCol, setHiddenCol] = useState(false)
  const [filterType, setFilterType] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null);
  const openEL = Boolean(anchorEl);

  const linkCategorySelector = useSelector((state) => state.linkCategory);
  const { status } = linkCategorySelector;

  const unLinkCategorySelector = useSelector((state) => state.unlinkCategory);
  const { status: statusUnLink } = unLinkCategorySelector;



  const kaColomns = [
    {
      field: 's_no',
      headerName: 'S. No.',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      filterable: false,
      renderCell: (index) => index.api?.getRowIndexRelativeToVisibleRows(index.row._id) + 1,
    },
    {
      field: '_id',
      headerName: 'ID',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'name',
      headerName: 'Name',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'image',
      headerName: 'Image',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <>
            <img width={40} src={params?.row?.images?.mobile} />
          </>
        )
      },
    },
    {
      field: 'price',
      headerName: 'Price',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (
          <>
            <Stack>
              {params?.row?.price?.denominations?.map((price, idx) => {
                return <Typography key={idx}>{price}</Typography>
              })}
            </Stack>
          </>
        )
      },
    },
    {
      field: 'country',
      headerName: 'Country',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <Typography>
          {params?.row?.country?.[0]?.name ??
            params?.row?.country?.name ??
            "—"}
        </Typography>
      ),
    },
    {
      field: 'wallet',
      headerName: 'Wallet',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'profit', headerName: 'Add Profit',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => navigate(`/detailCoupon?SKU=${params?.row?.sku}&prices=${params?.row?.price?.denominations}`)}><LinkIcon color='primary' />
          </IconButton>
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'category',
      headerName: 'Linked Category',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
      renderCell: (params) => <Typography>{params?.row?.category?.name}</Typography>
    },
    {
      field: 'link_category', headerName: 'Link Category',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setLinkCategory(true);
              propsData = {
                sku: params?.row?.sku,
              };
            }}><LinkIcon color='primary' />
          </IconButton>
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'unlink_category',
      headerName: 'Un-Link Category',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setUnLinkCategory(true);
              propsData = {
                catId: params?.row?.category?.category_id,
                sku: params?.row?.sku,
                is_deleted: true,
              };
            }}><LinkOffIcon color='primary' />
          </IconButton>
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'edit', headerName: 'Edit Category',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              navigate(`/editkalist?couponId=${params?.row._id}`);
            }}><EditIcon color='primary' />
          </IconButton>
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
    },
    {
      field: 'delete',
      headerName: 'Delete Category',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              handleOpen();
              setIsDeleteId(params?.row._id);
            }}><DeleteIcon color='error' />
          </IconButton>
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 150,
      hide: true,
    },
    {
      field: 'revert',
      headerName: 'Revert Category',
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              setIsDeleteId(params?.row._id);
              restoreHandler();
            }}
          ><RestoreIcon color='success' />
          </IconButton>
        )
      },
      headerClassName: 'super-app-theme--header',
      flex: 1,
      hide: true,
    },
    {
      field: 'expiry',
      headerName: 'Expiry',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'created_at',
      headerName: 'Created At',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'updated_at',
      headerName: 'Updated At',
      headerClassName: 'super-app-theme--header',
      flex: 1,
      minWidth: 200,
    },
  ]


  const deleteHandler = async () => {
    const res = await axios.delete("/admin/ka-voucher", {
      data: { voucherId: isdeleteId, is_deleted: true },
    });
    const data = await res.data;
    if (data) {
      handleClose();
      setCoupons([]);
      fetchCoupon();
    }
  };
  const restoreHandler = async () => {
    const res = await axios.delete("/admin/ka-voucher", {
      data: { voucherId: isdeleteId, is_deleted: false },
    });
    const data = await res.data;
    if (data) {
      handleClose();
      setCoupons([]);
      fetchCoupon();
    }
  };

  const fetchCoupon = () => {
    setPage(0);
    // setLoad(true);
    setIsMore(false);

    //console.log("-->", isDeleted);
    axios.get(`/admin/ka-vouchers?is_deleted=${filterType}`).then((res) => {
      //console.log("data-->", res.data.response);
      let data = res.data.response;
      if (res.data.status) {
        setCoupons(res.data.response);
        if (data && data.length < limit) {
          setIsMore(true);
        }
        if (data.length === 0) {
          setNodata(true);
        } else {
          setNodata(false);
        }
        setPage(1);
      }
    });
  };


  const handleCloseMenu = (event) => {
    setAnchorEl(null);
    if (event.target.innerText == 'True') {
      setFilterType(true)
    } else {
      setFilterType(false)
    }
  };

  const handleAmountEl = (event, value) => {
    setAnchorEl(event.currentTarget);
  }


  useEffect(() => {
    fetchCoupon();
  }, [filterType, limit, status, statusUnLink]);


  return (
    <>
      <Body>
        <Button sx={{ mb: 2 }} variant="contained" onClick={handleAmountEl}>Is Deleted</Button>
        <Menu
          anchorEl={anchorEl}
          open={openEL}
          onClose={handleCloseMenu}
          anchorOrigin={{ vertical: 'top', horizontal: 'left', }}
          transformOrigin={{ vertical: 'top', horizontal: 'left', }}
        >
          <MenuItem onClick={handleCloseMenu}>True</MenuItem>
          <MenuItem onClick={handleCloseMenu}>False</MenuItem>
        </Menu>


        <Paper sx={{
          bgcolor: '#fff',
          '& .super-app-theme--header': {
            bgcolor: '#DC8449',
            color: '#fff',
          },
        }} elevation={0}>


          <DataGrid
            className={classes.root}
            sx={{
              border: 0,
            }}
            hideFooterPagination
            getRowHeight={() => 'auto'}
            autoHeight
            rows={coupons}
            columns={kaColomns}
            getRowId={(row) => row._id}
            disableSelectionOnClick
            disableRowSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            //  pagination
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[25, 50, 100]}
            disableColumnSelector
            columnVisibilityModel={{
              delete: !filterType,
              revert: filterType
            }}
          />
        </Paper>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box style={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Are you Sure you want to Delete?
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <Button
                onClick={() => {
                  deleteHandler();
                }}
              >
                Yes
              </Button>
              <Button onClick={handleClose}>No</Button>
            </Typography>
          </Box>
        </Modal>
      </Body>

      {/* </section> */}

      {/* modal */}
      {
        linkCategory && (
          <LinkCategory
            linkCategory={linkCategory}
            setLinkCategory={setLinkCategory}
            propsData={propsData}
          />
        )
      }
      {
        unlinkCategory && (
          <UnLinkCategory
            unlinkCategory={unlinkCategory}
            setUnLinkCategory={setUnLinkCategory}
            propsData={propsData}
          />
        )
      }
    </>
  );
}

export default Kacoupon;
